export default __webpack_public_path__ + "static/media/benefit-4-cf.d35251cd.svg";